// extracted by mini-css-extract-plugin
export var errorsContainer = "_ug-1";
export var link = "_ug-0";